<span [ngClass]="!state ? textDefaultClass : textHighClass">{{text}}</span>